/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function UserGroupRepresentationFromJSON(json) {
    return UserGroupRepresentationFromJSONTyped(json, false);
}
export function UserGroupRepresentationFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: json['id'],
        name: json['name'],
        userIds: json['userIds'],
        areSuperUsers: !exists(json, 'areSuperUsers') ? undefined : json['areSuperUsers'],
    };
}
export function UserGroupRepresentationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        name: value.name,
        userIds: value.userIds,
        areSuperUsers: value.areSuperUsers,
    };
}
